import { PointerEventTypes, PointerInfo } from '@babylonjs/core/Events/pointerEvents'

import { MeshPoints } from '../meshPoints/meshPoints.tool'
import { BabylonToolConfig, MouseButtonCodes } from '../../../../../types'

export class Arrow extends MeshPoints {
    static NAME = 'ANGLED JOISTS'

    constructor(config: BabylonToolConfig) {
        super(config)
        this.name = Arrow.NAME
    }

    /**
     * Handle pointer observable event and emit the correct
     * events on measurement points change
     * @param evt pointer observable event
     * @returns
     */
    protected selectPoint = (evt: PointerInfo) => {
        if (evt.type !== PointerEventTypes.POINTERDOWN) return
        const pick = this.pickWithRayPicker()
        const leftClicked = evt.event.button === MouseButtonCodes.Left
        const hitAMesh = pick && pick.hit

        if (!leftClicked) return

        if (!hitAMesh) {
            this.clearDirectionAndPoints()

            return
        }

        if (this.meshPoints.length < 2) {
            if (pick && pick.pickedPoint) {
                this.meshPoints.push(pick.pickedPoint)
            }
            this.mediator.mediate('3D', {
                meshPoints: this.meshPoints.map((vector) => {
                    return { x: vector.x, y: vector.y, z: vector.z }
                }),
            })
        } else {
            this.clearDirectionAndPoints()
        }

        if (this.meshPoints.length === 2) {
            const directionOther = `[(${this.meshPoints[0].x.toFixed(3)},${this.meshPoints[0].y.toFixed(
                3
            )}),(${this.meshPoints[1].x.toFixed(3)},${this.meshPoints[1].y.toFixed(3)})]`

            this.mediator.mediate('common', {
                joistDirectionOtherCoordinates: directionOther,
            })
        }
    }

    private clearDirectionAndPoints = () => {
        this.meshPoints = []
        this.mediator.mediate('common', { joistDirectionOtherCoordinates: null })
        this.mediator.mediate('3D', { meshPoints: null })
    }
}
